import { useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useMyContentContext } from '../utils/myContentContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faEye, faPenToSquare, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ConfirmationModal from '../../../components/ConfirmationPopUp';
import Modal from '../../../components/Modal';
import { useRenameQuestionDocumentMutation,
  useUpdateResourceDisplayMutation,
  useDeleteQuestionDocumentMutation,
  useMoveQuestionDocumentMutation } from '../../../features/authentication/qSetApiSlice';
import CustomToast from '../../../components/Toast';
import { useGetResourceDocMutation } from '../../../features/authentication/assignmentApislice';
import VideoModal from '../../assignments/components/questionDetailComponents/VideoModal';
import DocumentModal from '../../assignments/components/questionDetailComponents/DocumentModal';
import AudioModal from '../../assignments/components/questionDetailComponents/AudioModal';
import ImageModal from '../../assignments/components/questionDetailComponents/ImageModal';
import Dropdown from '../../../../src/components/DropDown/index';
import { useParams } from 'react-router';

const QuestionResources = () => {
  const [isMouseOver, setIsMouseOver] = useState(false);
  const [openConfirmModel, setOpenConfirmModel] = useState(false);
  const [removedDocumentId, setRemovedDocumentId] = useState(0);
  const [openDocumentRenameModel, setOpenDocumentRenameModel] = useState(false);
  const [documentName, setDocumentName] = useState('');
  const [renameDocumentId, setRenameDocumentId] = useState(0);
  const [videoModal, setVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [audioUrl, setAudioUrl] = useState('');
  const [imageUrl] = useState('');
  const [documentModal, setDocumentModal] = useState(false);
  const [audioModal, setAudioModal] = useState(false);
  const [getResourceDoc] = useGetResourceDocMutation();
  const [documentText, setDocumentText] = useState('');
  const [imageModal, setImageModal] = useState(false);
  const [renameDocument] = useRenameQuestionDocumentMutation();
  const [updateResourceDisplay] = useUpdateResourceDisplayMutation();
  const [deleteQuestionDocument] = useDeleteQuestionDocumentMutation();
  const [moveQuestionDocument] = useMoveQuestionDocumentMutation();
  const { questionId } = useParams();
  const { questionDocuments, setQuestionDocuments, selectedDocumentIds, setSelectedDocumentIds } = useMyContentContext();
  const resourceDisplay = [
    { id: 1, name: 'As an attached resource' },
    { id: 2, name: 'To the left of the question' }
  ];

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(questionDocuments);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    if (result.source.index != result.destination.index) {
      updateDocumentPosition(parseInt(result.draggableId), result.source.index + 1, result.destination.index + 1);
      if(questionId)
        updateDocumentPositionsAsync(items.map(item=>item.documentId));
      setQuestionDocuments(items);
    }
  };

  const handleQuestionDisplay = (resourceId, selectedDisplayId) => {
    const items = Array.from(questionDocuments);
    const updatedResources = items.map((item) => {
      return item.documentId == resourceId ? { ...item, displayWithQuestion: selectedDisplayId == 2 } : { ...item };
    });
    if (questionId)
      updateResourceDisplayAsync(resourceId, selectedDisplayId == 2);
    setQuestionDocuments(updatedResources);
  };

  const updateDocumentPositionsAsync = async (documents) => {
    let option = {
      questionId:questionId,
      documents: documents
    };
    const response = await moveQuestionDocument(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    }
  };

  const updateResourceDisplayAsync = async (documentId, displayWithQuestion) => {
    const option = {
      questionId: questionId,
      documentId: documentId,
      displayWithQuestion: displayWithQuestion
    };
    const response = await updateResourceDisplay(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    }
  };

  const updateDocumentPosition = async (documentId, initialPosition, finalPosition) => {
    if (finalPosition > questionDocuments.length)
      finalPosition = questionDocuments.length;

    finalPosition = questionDocuments[finalPosition - 1].position;
    initialPosition = questionDocuments[initialPosition - 1].position;

    let updatedResources = questionDocuments;
    if (initialPosition < finalPosition) {
      updatedResources = updatedResources.map(item => {
        if (item.position > initialPosition && item.position <= finalPosition) {
          return { ...item, position: item.position - 1 };
        }
        return item;
      });
    } else {
      updatedResources = updatedResources.map(item => {
        if (item.position >= finalPosition && item.position < initialPosition) {
          return { ...item, position: item.position + 1 };
        }
        return item;
      });
    }

    updatedResources = updatedResources.map(item => {
      if (item.position === initialPosition && item.documentId == documentId) {
        return { ...item, position: finalPosition };
      }
      return item;
    });
    updatedResources.sort((a, b) => a.position - b.position);
    setQuestionDocuments(updatedResources);
  };

  const handleRemove = () => {
    const newDocuments = questionDocuments.filter(obj => obj.documentId != removedDocumentId);
    setQuestionDocuments(newDocuments);
    const newSelectedDocIds = selectedDocumentIds.filter(id => id != removedDocumentId);
    setSelectedDocumentIds(newSelectedDocIds);

    if(questionId)
      deleteResourceAsync(removedDocumentId);

    setOpenConfirmModel(false);
    setRemovedDocumentId(0);
  };

  const deleteResourceAsync = async (documentId) =>{
    let option = {
      questionId:questionId,
      documentId: documentId
    };
    const response = await deleteQuestionDocument(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      CustomToast('Resource deleted successfully.', 'success');
    }
  };

  const renameDocumentAsync = async () => {
    let option = {
      questionId:questionId,
      documentId: renameDocumentId,
      documentName: documentName
    };
    const response = await renameDocument(option);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Error, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      const updatedData = questionDocuments.map((item) =>
        item.documentId == renameDocumentId ? { ...item, description: documentName } : item
      );
      setQuestionDocuments(updatedData);
      CustomToast('Document renamed successfully.', 'success');
      setOpenDocumentRenameModel(false);
      setRenameDocumentId(0);
      setDocumentName('');
    }
  };

  const viewActionButton = (index, resource) => {
    return <>
      <OverlayTrigger
        key="viewToolTip"
        placement="top"
        overlay={<Tooltip className="custom-tooltip">View</Tooltip>}>
        <button
          id={'view' + index}
          className="action-btn-tile yellow m-0 mt-2"
          onClick={() => resourceViewHandler(resource.type, resource.documentId, resource.url)}
        >
          <FontAwesomeIcon icon={faEye} />
        </button>
      </OverlayTrigger>
    </>;
  };

  const resourceViewHandler = async (resourceType, resourceId, resourceUrl) => {
    setDocumentText('');
    let link;
    switch (resourceType) {
    case 'Video':
      setVideoModal(true);
      setVideoUrl(resourceUrl);
      break;
    case 'Document':
      try {
        const option = { documentId: resourceId };
        setDocumentModal(true);
        const response = await getResourceDoc(option).unwrap();
        setDocumentText(response.resourceText);
      } catch (error) {
        console.error(error);
      }
      break;
    case 'Audio':
      setAudioModal(true);
      setAudioUrl(resourceUrl);
      break;
    case 'Link':
    case 'PDF':
    case 'MS Word':
    case 'Power Point':
      link = document.createElement('a');
      link.href = resourceUrl;
      link.target = '_blank';
      link.click();
      break;
    default:
      console.warn('Unknown resource type: ', resourceType);
    }
  };

  return (
    <>
      <div onMouseEnter={() => setIsMouseOver(false)} onMouseLeave={() => setIsMouseOver(true)}>
        <div className='line'></div>
        <h5 className='mb-3 mt-3 text-center'>Documents</h5>
        <div className='line'></div>
        <p className='text-success mt-2'>To move a document just drag the header from one location to another.</p>
        <div className='mt-4'>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId='rows'>
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {questionDocuments.map((item, index) => (
                    <>
                      <Draggable key={item.documentId} draggableId={`${item.documentId}`} index={index}>
                        {(provided, snapshot) => (
                          <div key={'castleRes' + index} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                            className={`mt-2 border-grey ${snapshot.isDragging && 'drag-style'} ${(isMouseOver && snapshot.isDragging) && ' cursor-not-allowed'}`}>
                            <div key={index} className='w-100'>

                              <div className="d-flex justify-content-between align-items-center">
                                <OverlayTrigger
                                  key="viewToolTip"
                                  placement="top"
                                  overlay={<Tooltip className="custom-tooltip">Grab to Drag</Tooltip>}>
                                  <div
                                    id={'view' + index}
                                    className="align-items-center border-0 btn cursor-grab d-flex">
                                    <FontAwesomeIcon icon={faBars} />
                                  </div>
                                </OverlayTrigger>
                                <div className="d-flex align-items-baseline flex-row mt-2 col-10 gap-3">
                                  <h6>{item.description}</h6>
                                  <div className='d-flex align-items-baseline gap-1'>
                                    <label className='w-30'>Display :</label>
                                    <Dropdown
                                      value={resourceDisplay}
                                      onChangeHandler={(e) => handleQuestionDisplay(item.documentId, e.target.value)}
                                      selectedValue={item.displayWithQuestion ? 2 : 1}
                                      dropDownName={'Display'}
                                    />
                                  </div>
                                </div>
                                <div>
                                  <OverlayTrigger
                                    key="assignmentsUsed"
                                    placement="top"
                                    overlay={<Tooltip className="custom-tooltip">
                                      Rename
                                    </Tooltip>}>
                                    <button
                                      onClick={() => { setOpenDocumentRenameModel(true); setDocumentName(item.description); setRenameDocumentId(item.documentId); }}
                                      className={'btn grid-icon-btn info-icon-btn mr-2'}>
                                      <FontAwesomeIcon icon={faPenToSquare} />
                                    </button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    key="deleteQuestion"
                                    placement="top"
                                    overlay={<Tooltip className="custom-tooltip">Delete</Tooltip>}>
                                    <button className="btn grid-icon-btn danger-icon-btn mr-2" onClick={() => { setOpenConfirmModel(true); setRemovedDocumentId(item.documentId); }}>
                                      <FontAwesomeIcon icon={faTrashAlt} />
                                    </button>
                                  </OverlayTrigger>
                                  {viewActionButton(index, item)}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    </>
                  ))}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      {openDocumentRenameModel &&
        <Modal
          contentWidth="600px"
          isOpen={openDocumentRenameModel}
          titleName={'Rename Document'}
          onClose={() => { setOpenDocumentRenameModel(false); setDocumentName(''); }}>
          <p>Folder Name</p>
          <input
            type="text"
            className='form-control'
            placeholder=" "
            name="renameDocument"
            id="renameDocument"
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
          />
          {documentName == '' &&
            <div className="text-danger">Document name cannot be empty!</div>
          }
          <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
            <button className="btn btn-castleGray print-btn" onClick={() => setOpenDocumentRenameModel(false)}>
              Cancel
            </button>
            <button className="btn btn-castleRed print-btn" onClick={() => renameDocumentAsync()}>
              Save
            </button>
          </div>
        </Modal>
      }
      <ConfirmationModal
        isOpen={openConfirmModel}
        onClose={() => setOpenConfirmModel(false)}
        titleName='Remove Document'
        onSave={() => handleRemove()}
        cancelButton='No'
        confirmButton='Yes'
        contentWidth='35%'
        buttonPosition='center'
        content='Are you sure you want to remove this document? You can always re-attach it.'
      />
      <VideoModal videoUrl={videoUrl} isOpen={videoModal} onClose={() => setVideoModal(false)} />
      <DocumentModal value={documentText} isOpen={documentModal} onClose={() => setDocumentModal(false)} />
      <AudioModal audioUrl={audioUrl} isOpen={audioModal} onClose={() => setAudioModal(false)} />
      <ImageModal imageUrl={imageUrl} isOpen={imageModal} onClose={() => setImageModal(false)} />
    </>
  );
};

export default QuestionResources;
